import React from 'react';

// Libraries
import classNames from 'classnames';

enum PROGRESS_BAR_SIZES {
  BOLD = 'bold',
  SLIM = 'slim',
  EXTRA_SLIM = 'extra-slim',
}

export type Props = {
  hidePercentageText?: boolean;
  progress: number;
  size?: PROGRESS_BAR_SIZES;
};

const ProgressBar: React.FC<Props> = ({ hidePercentageText, progress, size }) => {
  const barSize = size || PROGRESS_BAR_SIZES.SLIM;
  const maxPercentage = 100;

  const renderPercentageValue = () => {
    if (!hidePercentageText) {
      return (
        <div className="percentage-value">
          {progress < maxPercentage && <span>{progress}%</span>}
          {progress >= maxPercentage && <i className="icon-ds-check-circle-outline" />}
        </div>
      );
    }

    return null;
  };

  return (
    <div className={classNames('progress-bar', { 'is-completed': progress >= maxPercentage })}>
      <div className={classNames('bar', barSize)}>
        <span className="percentage" style={{ width: `${progress}%` }} />
      </div>

      {renderPercentageValue()}
    </div>
  );
};

export default ProgressBar;
